import React, { memo } from 'react'

import TableHeader from 'material-table/dist/components/m-table-header'

// eslint-disable-next-line react/prop-types
const Header = memo(({ tableHeaderClassName, sortLabelClasses, ...props }) => (
  <TableHeader
    { ...props }
    classes={ { header: tableHeaderClassName } }
    sortLabelClasses={ sortLabelClasses }
  />
))

export default Header
